<div class="select-form--wrapper">
  <nx-formfield
    [label]="field.label | translate"
    [formGroup]="formGroup"
    *ngIf="field && formGroup.controls[field.name]"
  >
    <nx-dropdown
      [attr.placeholder]="field.placeholder ?? '' | translate"
      [formControlName]="field.name"
      [showFilter]="field.searchbar?.show || false"
      [filterPlaceholder]="field.searchbar?.label ? (field.searchbar?.label ?? '' | translate) : ''"
      [filterFn]="field.searchbar?.show ? (field.searchbar?.fnFilter ?? onFilter) : filterNull"
      [ignoreItemTruncation]="field.ignoreTrunctation || false"
      (closed)="onClose()"
    >
      <ng-container *ngFor="let item of field?.list">
        <ng-container
          [ngTemplateOutlet]="field.hasOptGroup ? dropdownOptGroup : dropdownItem"
          [ngTemplateOutletContext]="{item: item | checkSelected: {field, stepName}}"
        >
        </ng-container>
      </ng-container>

      <ng-template #dropdownOptGroup let-item="item">
        <nx-dropdown-group [label]="item.label">
          <ng-container
            *ngFor="let el of item.list"
            [ngTemplateOutlet]="dropdownItem"
            [ngTemplateOutletContext]="{item: el | checkSelected: {field, stepName}}"
          ></ng-container>
        </nx-dropdown-group>
      </ng-template>

      <ng-template #dropdownItem let-item="item">
        <nx-dropdown-item [value]="item.value">
          {{ item.text | translate }}
        </nx-dropdown-item>
      </ng-template>

      <ng-template nxClosedLabel *ngIf="field.formattedValue">
        <span>{{ field.formattedValue | translate: formGroup.controls[field.name].value }}</span>
      </ng-template>
    </nx-dropdown>
    <app-popover-form
      *ngIf="field.popover"
      nxFormfieldSuffix
      [popover]="field.popover"
      (popoverShow)="onPopoverShow($event)"
    ></app-popover-form>

    <nx-error
      nxFormfieldError
      *ngFor="
        let item of (!field.hideErrorBox && formGroup.controls[field.name]?.errors) || {}
          | arrayKeys
      "
    >
      {{
        (field.customErrorLabel && field.customErrorLabel[item]
          ? field.customErrorLabel[item]
          : 'azForm.errors.' + item
        ) | translate
      }}
    </nx-error>
  </nx-formfield>
</div>
